import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import PageHero from "../components/PageHero";

const WEB3FORMS_ACCESS_KEY = "73ee46f9-bbb7-4ca0-8c37-f0456ddb28ac";

const EMPTY = { name: "", email: "", message: "" };

export default function Contact() {
  const [form, setForm] = useState(EMPTY);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  const update = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.name.trim()) return setError("Please enter your name.");
    if (!/^\S+@\S+\.\S+$/.test(form.email.trim())) return setError("Please enter a valid email.");
    if (!form.message.trim()) return setError("Please enter a message.");

    setSending(true);
    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          subject: "New Contact Message — Instafrnd",
          from_name: "Instafrnd Contact Form",
          name: form.name,
          email: form.email,
          message: form.message,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setSubmitted(true);
        setForm(EMPTY);
        return;
      }
      throw new Error("Server error");
    } catch (_) {
      setError("Something went wrong. Please email connect@instafrnd.com directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us — Instafrnd</title>
        <meta name="description" content="Get in touch with the Instafrnd team. Reach us by email, phone, or the contact form." />
        <link rel="canonical" href="https://instafrnd.com/contact" />
        <meta property="og:url" content="https://instafrnd.com/contact" />
        <meta property="og:title" content="Contact Us — Instafrnd" />
        <meta property="og:description" content="Get in touch with the Instafrnd team. Reach us by email, phone, or the contact form." />
      </Helmet>
      <PageHero
        eyebrow="Contact Us"
        title="We'd love to hear from you."
        subtitle="Questions, feedback, partnerships, or support — reach out and our team will get back to you."
      />

      <section className="section-pad">
        <div className="wrap">
          <div className="card-grid">
            <div className="info-card reveal">
              <div className="ic">✉️</div>
              <h3>Email</h3>
              <p><a href="mailto:connect@instafrnd.com">connect@instafrnd.com</a></p>
            </div>
            <div className="info-card reveal" style={{ transitionDelay: "0.08s" }}>
              <div className="ic">📞</div>
              <h3>Phone</h3>
              <p><a href="tel:+919663609788">+91 96636 09788</a></p>
            </div>
            <div className="info-card reveal" style={{ transitionDelay: "0.16s" }}>
              <div className="ic">📍</div>
              <h3>Registered Office</h3>
              <p>
                Spynzo (OPC) Private Limited<br />
                Sy.No. 31/2, PL Skyship Layout, Seegehalli,<br />
                Kadugudi, Bangalore, Karnataka - 560067
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-pad" style={{ paddingTop: 0 }}>
        <div className="wrap">
          <form className="form-card reveal" onSubmit={onSubmit} noValidate>
            <div className="form-row">
              <div className="field">
                <label htmlFor="name">Name *</label>
                <input id="name" name="name" value={form.name} onChange={update} placeholder="Your full name" />
              </div>
              <div className="field">
                <label htmlFor="email">Email *</label>
                <input id="email" name="email" value={form.email} onChange={update} placeholder="you@example.com" />
              </div>
            </div>
            <div className="field" style={{ marginBottom: 22 }}>
              <label htmlFor="message">Message *</label>
              <textarea id="message" name="message" value={form.message} onChange={update} rows={5} placeholder="How can we help?" />
            </div>
            <button className="btn btn-primary" type="submit" disabled={sending} style={{ width: "100%", justifyContent: "center", padding: "14px", opacity: sending ? 0.7 : 1, cursor: sending ? "not-allowed" : "pointer" }}>
              {sending ? "Sending…" : "Send Message"}
            </button>
            {error && <div className="form-note" style={{ color: "#E5484D" }}>{error}</div>}
            {submitted && <div className="form-note ok">🎉 Thanks! Your message is in. We'll reply soon.</div>}
          </form>
        </div>
      </section>
    </>
  );
}
